import { sampleScenario } from "constants/sampleScenario";
import { useConsoleState } from "providers/ConsoleStateProvider";
import React from "react";
import { useHistory } from "react-router-dom";
import { Scenario } from "types/graphqlapi";
import { fetchScenarioBysubjectIdQuery } from "utils/apis/scenario";

export type ScenarioTemplateSet = {
  scenario: Partial<Scenario>;
  templates: Partial<Scenario>[];
};

export const useSenarioTemplateSet = () => {
  const { selectedSubjectId } = useConsoleState();
  const history = useHistory();

  const [scenarioTemplateSet, setScenarioTemplateSet] = React.useState<
    ScenarioTemplateSet[]
  >([]);

  const fetchScenario = React.useCallback(async () => {
    try {
      const scenarioDataList = await fetchScenarioBysubjectIdQuery(
        selectedSubjectId
      );

      if (scenarioDataList.length >= 1) {
        const scenarioList = scenarioDataList.filter(
          (scenarioData) => scenarioData.template_no === 0
        );

        const templateList = scenarioDataList.filter(
          (scenarioData) => scenarioData.template_no !== 0
        );

        const arrangedScenario: ScenarioTemplateSet[] = scenarioList.map(
          (scenario) => {
            return {
              scenario: scenario,
              templates: templateList.filter(
                (template) => template.scenario_no === scenario.scenario_no
              ),
            };
          }
        );

        setScenarioTemplateSet(arrangedScenario);
      } else {
        setScenarioTemplateSet(sampleScenario);
      }
    } catch (e) {
      console.error(e);
      history.push("error");
    }
  }, [selectedSubjectId, history]);

  React.useEffect(() => {
    fetchScenario();
  }, [fetchScenario]);

  return { scenarioTemplateSet, fetchScenario };
};
